import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {QuestionTileBase} from '../question-tile/question-tile-base.component';

@Component({
    selector: 'app-question-tile-checkbox',
    templateUrl: '../question-tile/question-tile-base.component.html',
    styleUrls: ['../question-tile/question-tile-base.component.scss'],
    standalone: false
})
export class QuestionTileCheckboxComponent extends QuestionTileBase {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Input() labelText = '';
  @Input() showItk = false;
  @Output() questionAnswer = new EventEmitter<any>();

  protected readonly tileVariant = 'checkbox' as const;

  constructor(questionService: GlobalQuestionService) {
    super(questionService);
  }
}
